import { Field,ErrorMessage} from "formik";
import './Input.scss'


const Input = ({typeInput,className,label,name,placeholder,error,...restProps})=>{

return (
    <>
    
    <label  htmlFor="">
      <p className="form-label">{label}</p>
        <Field type={typeInput} className={className}  name={name} placeholder={placeholder} {...restProps} />
        <ErrorMessage className="error-message" name={name} component='p'/>
    </label>
    
    </>
)

}

export default Input;